import React, { useCallback, CSSProperties, useEffect, useRef } from "react"
import { navigate } from "gatsby"
import classnames from "classnames"
import * as styles from "./roles-bar.module.css"
import { roles } from "./TopBar/Roles/RolesTypes"

type mode = "customer" | "employee" | "solutions" | "products"
const mainStyles: Record<mode, string> = {
  customer: styles.customer,
  products: styles.customer,
  employee: styles.employee,
  solutions: styles.employee,
}

const getSlugName = (slug: string): string => slug.split("/")?.slice(-1)[0]

export function Bar({
  selected,
  mode,
  links,
  goBack,
  text,
  simple,
  position = "right",
  linkColor = "white",
  selectedTextColor = "#005cb9",
  style,
  reverseColoring,
  stylesModule,
}: {
  selected?: string
  mode: mode
  links: {
    name: string
    slug: string
  }[]
  goBack: boolean
  text: string
  simple?: boolean
  position?: "left" | "right"
  linkColor?: string
  selectedTextColor?: string
  style?: CSSProperties
  reverseColoring?: boolean
  stylesModule?: any
}) {
  const navigateTo = useCallback(
    (url: string) =>
      selected
        ? navigate(
            "/" +
              url
                .split("/")
                .filter(x => x.length > 0)
                .join("/")
          )
        : navigate(
            "/" +
              url
                .split("/")
                .filter(x => x.length > 0)
                .join("/"),
            { state: { animate: true } }
          ),
    [selected]
  )

  const font = "body-font"
  const mainStyle = mainStyles[mode]

  const colorMode = mode === "employee" ? "0,169,143" : "0,92,185"

  const rolesContainer = useRef<HTMLDivElement>(null)
  const selectContainer = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const currentSelectedSlug = getSlugName(window.location.pathname)
    const indexOfCurrentSlug = links.findIndex(
      x => getSlugName(x.slug) === currentSelectedSlug
    )
    const slug =
      links[
        indexOfCurrentSlug !== 0 ? indexOfCurrentSlug - 1 : indexOfCurrentSlug
      ]?.slug

    const slugName = slug && getSlugName(slug)
    const element = slugName && document.getElementById(slugName)

    const leftOfCurrentSelected =
      element &&
      element.getBoundingClientRect().left -
        (!simple ? selectContainer.current?.offsetWidth || 0 : 0)

    if (
      leftOfCurrentSelected &&
      rolesContainer.current &&
      currentSelectedSlug !== getSlugName(links[0]?.slug)
    ) {
      rolesContainer.current.scrollTo({
        left: leftOfCurrentSelected,
        behavior: "smooth",
      })
    }
  }, [rolesContainer])

  return (
    <div
      className={classnames(
        styles.rolesContainer,
        selected ? styles.topContainer : styles.bottomContainer,
        mainStyle,
        simple ? styles.simple : "",
        stylesModule?.rolesContainer
      )}
      style={{ [position]: 0, ...style }}
    >
      {!simple && (
        <div
          className={classnames(
            "body-font",
            styles.select,
            stylesModule?.role__select
          )}
          ref={selectContainer}
          style={{ backgroundColor: `rgb(${colorMode})` }}
        >
          <span>
            {text} <span>ᐳᐳ</span>
          </span>
        </div>
      )}
      <div
        className={classnames(
          styles.rolesBoxContainer,
          stylesModule?.rolesBoxContainer
        )}
        ref={rolesContainer}
      >
        {links.map(({ slug, name }, i) => (
          <div
            key={slug}
            id={getSlugName(slug)}
            onClick={() => navigateTo(slug)}
            style={{
              backgroundColor: !reverseColoring
                ? `rgba(${colorMode}, ${1 - (i + 1) / links.length})`
                : `rgba(${colorMode}, ${(i + 1) / links.length})`,
            }}
            className={classnames(
              styles.box,
              !simple && i === links.length - 1 ? styles.last : "",
              font,
              !goBack && selected === name ? styles.selected : null,
              stylesModule?.role__box
            )}
          >
            <span
              style={{
                color: selected === name ? selectedTextColor : linkColor,
              }}
            >
              {name}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
export default function Roles({
  mode,
  selected,
  goBack,
  position,
  showText = true,
  style,
  styles,
  text = "SELECT ROLE",
}: {
  mode: mode
  selected?: string
  goBack?: boolean
  showText?: boolean
  position?: "left" | "right"
  style?: CSSProperties
  styles?: any
  text?: string
}) {
  const roles_ = roles["roles"]
    .map(x => ({
      ...x,
    }))
    .filter(x => x.type === mode)

  return (
    <Bar
      text={showText ? text : ""}
      links={roles_}
      goBack={!!goBack}
      selected={selected}
      mode={mode}
      position={position}
      style={style}
      stylesModule={styles}
    ></Bar>
  )
}
